import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '../views/HomeView.vue'
import PayProvidersView from '../views/PayProvidersView.vue'
import ProviderView from '../views/ProviderView.vue'
import AmountView from '../views/AmountView.vue'
import DenominationsView from '../views/DenominationsView.vue'
import PayView from '../views/PayView.vue'
import CryptoView from '../views/CryptoView.vue'
import NotFound from '../views/NotFoundView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '/groups/:groupId',
    name: 'groups',
    component: PayProvidersView,
    meta: {
      watchParam: 'groupId'
    }
  },
  {
    path: '/provider/:providerId',
    name: 'provider',
    component: ProviderView
  },
  {
    path: '/denominations',
    name: 'denominations',
    component: DenominationsView
  },
  {
    path: '/amount',
    name: 'amount',
    component: AmountView
  },
  {
    path: '/pay',
    name: 'pay',
    component: PayView,
    props: (route) => ({
      phone: route.query.phone || '',
      amount: route.query.amount || '',
      provider: route.query.provider ? JSON.parse(route.query.provider) : null
    })
  },
  {
    path: '/crypto',
    name: 'crypto',
    component: CryptoView
  }
]

if (process.env.VUE_APP_SHOW_TERMS_AND_CONDITIONS === 'true') {
  routes.push(
    {
      path: '/privacy-policy',
      name: 'privacy_policy',
      component: () => import('../views/PrivacyPolicyView.vue')
    },
    {
      path: '/terms-and-conditions',
      name: 'terms_and_conditions',
      component: () => import('../views/TermsAndConditionsView.vue')
    },
    {
      path: '/cancellation-refund-policy',
      name: 'cancellation_refund_policy',
      component: () => import('../views/CancellationRefundPolicyView.vue')
    },
    {
      path: '/delivery-and-shipping-policy',
      name: 'delivery_and_shipping_policy',
      component: () => import('../views/DeliveryAndShippingPolicyView.vue')
    },
    {
      path: '/contacts-company',
      name: 'contacts_company',
      component: () => import('../views/ContactsCompanyView.vue')
    }
  )
}

routes.push(
  {
    path: '/api/:pathMatch(.*)*',
    name: 'api-passthrough',
    beforeEnter: () => {
      window.location.replace(window.location.href)
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  }
)

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
